'use es6';

import http from 'hub-http/clients/apiClient';
import { LIVE, STAGED } from 'DesignData/enums/StagingEnvironments';
import { formatPathSlug } from 'DesignData/lib/path';
const BASE_API_PATH = 'designmanager/v1/raw-assets';
/**
 *  GET designmanager/v1/raw-assets/:rawAssetId
 */

export function fetch(rawAssetId) {
  return http.get(`${BASE_API_PATH}/${rawAssetId}`);
}
/**
 *  PUT designmanager/v1/raw-assets/:rawAssetId
 */

export function save(rawAssetId, rawAsset) {
  return http.put(`${BASE_API_PATH}/${rawAssetId}`, {
    data: rawAsset
  });
}
/**
 * POST designmanager/v1/raw-assets
 */

export function create({
  path,
  source
}) {
  return http.post(`${BASE_API_PATH}/by-path/${formatPathSlug(path)}`, {
    data: {
      path,
      source
    }
  });
}
/**
 *  DELETE designmanager/v1/raw-assets/:rawAssetId
 */

export function del(rawAssetId) {
  return http.delete(`${BASE_API_PATH}/${rawAssetId}`);
}
/**
 *  DELETE designmanager/v1/raw-assets/bulk
 */

export function bulkDelete(rawAssetIds) {
  return http.delete(`${BASE_API_PATH}/bulk`, {
    query: {
      id: rawAssetIds
    }
  });
}
export function publish(rawAssetId) {
  return http.post(`${BASE_API_PATH}/${rawAssetId}/push-buffer-live`);
}
/**
 *  POST designmanager/v1/raw-assets/clone/by-path/:rawAssetPath
 */

export function cloneByPath(rawAssetPath, data) {
  // API will error if new label doesn't include extension, force it to
  const ext = rawAssetPath.split('.').pop();

  if (!data.label.endsWith(ext)) {
    data.label = `${data.label}.${ext}`;
  }

  return http.post(`${BASE_API_PATH}/clone/by-path/${formatPathSlug(rawAssetPath)}`, {
    data,
    query: {
      environmentId: STAGED
    }
  });
}
export function hasBufferedChanges(rawAssetId) {
  return http.get(`${BASE_API_PATH}/${rawAssetId}/has-buffered-changes`);
}
export function hasBufferedChangesByPath(path) {
  return http.get(`${BASE_API_PATH}/has-buffered-changes/by-path/${formatPathSlug(path)}`);
}
/**
 * PUT designmanager/v1/raw-assets/:rawAssetId/restore-deleted
 */

export function restoreDeleted(rawAssetId) {
  return http.put(`${BASE_API_PATH}/${rawAssetId}/restore-deleted`);
}
/**
 *  PUT designmanager/v1/raw-assets/by-path/:rawAssetPath
 */

export function saveByPath(rawAssetPath, data, options = {}) {
  return http.put(`${BASE_API_PATH}/by-path/${formatPathSlug(rawAssetPath)}`, {
    data,
    query: {
      environmentId: options.staging ? STAGED : LIVE
    }
  });
}